// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-modal {
    background: #f9f9f9;
    padding: 1.25rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    position: relative;
    margin-top: 2rem;
}

.chat-history {
    max-height: 240px;
    overflow-y: auto;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #ddd;
}

.chatbot-modal input {
    width: calc(100% - 120px);
    padding: 8px;
    margin-right: 10px;
    border-radius: 4px;
    border: 1px solid #aaa;
}

.chatbot-modal button {
    padding: 8px 16px;
    background: #0061b0;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.chatbot-modal .close {
    background: #b00020;
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AI/AIChatBotModal.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".chatbot-modal {\n    background: #f9f9f9;\n    padding: 1.25rem;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    position: relative;\n    margin-top: 2rem;\n}\n\n.chat-history {\n    max-height: 240px;\n    overflow-y: auto;\n    margin-bottom: 1rem;\n    padding: 0.5rem;\n    background: #fff;\n    border-radius: 6px;\n    border: 1px solid #ddd;\n}\n\n.chatbot-modal input {\n    width: calc(100% - 120px);\n    padding: 8px;\n    margin-right: 10px;\n    border-radius: 4px;\n    border: 1px solid #aaa;\n}\n\n.chatbot-modal button {\n    padding: 8px 16px;\n    background: #0061b0;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.chatbot-modal .close {\n    background: #b00020;\n    margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
